import { Stack, Typography, styled, Skeleton } from '@mui/material'
import { t } from '$i18n'
import { toLocale } from '$func/text'
import { PrimaryOutlinedButton } from '$common/buttons/primary-outlined-button'
import { ArrowIOSIcon } from '$common/icons'
import { PrimaryButton as CommonSecondaryButton } from '$common/buttons'
import { WappPanel } from '$logic/wapp-panels'

const StyledTitle = styled(Typography)`
  margin-left: 8px;
`

const SecondaryButton = styled(CommonSecondaryButton)(({ theme }) => ({
  marginRight: '22px',
  paddingRight: '16px',
  ...theme.typography.subtitle3,
}))

const OutlinedButton = styled(PrimaryOutlinedButton)(({ theme }) => ({
  marginRight: '22px',
  paddingRight: '16px',
  background: 'transparent',
  ...theme.typography.subtitle3,
  // TODO: set border opacity
  '&:hover': {
    background: 'transparent',
  },
  '&:active': {
    background: 'transparent',
  },
}))

const LoadingSkeleton = () => (
  <>
    <Skeleton height="24px" width="18px" />
    <Typography variant="subtitle3" color="semiLightGray" marginX="4px">
      /
    </Typography>
    <Skeleton height="24px" width="18px" />
  </>
)

const openCapacityForm = () =>
  WappPanel.openWapp({
    wappId: 'form-form-main',
    input: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      contentUri: import.meta.env.VITE_INVITAION_CAPACITY_FORM_CONTENT_URI,
    },
  })

export function InvitationStatusBar({
  invited,
  limit,
  loading,
}: {
  invited: number
  limit: number
  loading: boolean
}) {
  const errorMode = invited === limit && !!invited
  return (
    <Stack
      direction="row"
      width="100%"
      height="64px"
      justifyContent="center"
      alignItems="center"
      position="absolute"
      bottom="0"
      sx={{ backgroundColor: errorMode ? 'error.light' : 'success.light' }}
    >
      <StyledTitle
        variant="subtitle3"
        color={errorMode ? 'error.main' : 'success.main'}
      >
        {t('invite.invitationStatus')}
      </StyledTitle>
      {loading ? (
        <LoadingSkeleton />
      ) : (
        <>
          <Typography
            minWidth="18px"
            variant="subtitle3"
            color={errorMode ? 'error.main' : 'success.main'}
          >
            {toLocale(limit - invited)}
          </Typography>

          <Typography variant="subtitle3" color="semiLightGray" marginX="4px">
            /
          </Typography>

          <Typography
            minWidth="18px"
            variant="subtitle3"
            color={errorMode ? 'error.main' : 'success.main'}
          >
            {toLocale(limit)}
          </Typography>
        </>
      )}

      {errorMode ? (
        <SecondaryButton
          text={t('invite.increaseCapacity')}
          onClick={openCapacityForm}
          endIcon={<ArrowIOSIcon sx={{ color: 'white' }} />}
        />
      ) : (
        <OutlinedButton
          disableRipple
          endIcon={<ArrowIOSIcon />}
          text={t('invite.increaseCapacity')}
          onClick={openCapacityForm}
        />
      )}
    </Stack>
  )
}

// wappActivity://form/4a57a962-282f-46dd-b652-81e93386265d
